import store from '@/store'

export default {
  inserted(el, binding) {
    const { value } = binding
    const accessPermissionList = value
    const role = store.getters && store.getters.role
    const permissionList = store.getters && store.getters.permissions
    if (accessPermissionList && accessPermissionList instanceof Array && accessPermissionList.length > 0) {
      let hasPermission = false
      if (role !== 'ADMIN') {
        hasPermission = permissionList.some(permission => {
          return accessPermissionList.includes(permission)
        })
      } else {
        hasPermission = true
      }
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`使用方式： v-permission="['admin','editor']"`)
    }
  }
}
